export function useBRLmoney() {
  const BRLmoney = (value: number) => {
    if (!value) return "R$ 0";
    const convert = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    const convertToString = String(value);
    const getLength = convertToString.length;
    const finalDigits = `${convertToString[getLength - 2]}${
      convertToString[getLength - 1]
    }`;
    const removeFinalDigits = convertToString.slice(0, -2);
    const createNumber = `${removeFinalDigits}.${finalDigits}`;

    return `${convert.format(Number(createNumber))}`;
  };

  return { BRLmoney };
}
